import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const links = [
  { href: "/#quem-sou", label: "Quem sou" },
  { href: "/#frentes", label: "Frentes" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isInternalRoute = (href: string) => href.startsWith("/") && !href.startsWith("/#");

  return (
    <header
      className={cn(
        "fixed inset-x-0 top-0 z-50 transition-all duration-300",
        scrolled
          ? "border-b border-border/60 bg-background/70 backdrop-blur-xl"
          : "bg-transparent"
      )}
    >
      <nav className="mx-auto flex h-16 max-w-6xl items-center justify-between px-6">
        <Link to="/" className="font-serif text-xl tracking-tight text-foreground">
          Rodrigo<span className="text-accent">.</span>Haertel
        </Link>

        <div className="hidden items-center gap-8 md:flex">
          {links.map((l) => {
            const active = isInternalRoute(l.href) && pathname === l.href;
            const className = cn(
              "group relative text-sm transition-colors",
              active ? "text-foreground" : "text-muted-foreground hover:text-foreground"
            );
            return isInternalRoute(l.href) ? (
              <Link key={l.href} to={l.href} className={className}>
                {l.label}
                <span className="absolute -bottom-1 left-0 h-px w-0 bg-accent transition-all duration-300 group-hover:w-full" />
              </Link>
            ) : (
              <a key={l.href} href={l.href} className={className}>
                {l.label}
                <span className="absolute -bottom-1 left-0 h-px w-0 bg-accent transition-all duration-300 group-hover:w-full" />
              </a>
            );
          })}
        </div>

        <Button
          asChild
          size="sm"
          className="rounded-full bg-accent px-5 text-accent-foreground hover:bg-accent/90"
        >
          <Link to="/contato">Falar comigo</Link>
        </Button>
      </nav>
    </header>
  );
};

export default Navbar;
